import React from 'react';
import {connect} from 'react-redux';
import {DropdownButton, MenuItem} from "react-bootstrap";
import {URLs} from "../../common/constants";
import {redirectPage} from '../../common/utils';

import styles from "../../css/user-menu.less";

class SegmentsMenu extends React.Component {
    changeSegment = (eventKey) => {
        this.props.changeSegment(this.props.staticData, eventKey);
    };

    render() {
        return (
            <div className="user-menu hidden-xs">
                <DropdownButton className="menu-title hidden-xs"
                                title={this.props.segmentTitle}
                                id="segments-menu"
                                onSelect={this.changeSegment}>
                    {this.props.segments.map(segment => {
                        return <MenuItem eventKey={segment.key} key={segment.key}>{segment.name}</MenuItem>
                    })}
                </DropdownButton>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const segments = ((state.staticData || {}).segments || []);
    const segmentKey = ((state.staticData || {}).params || {}).segment;
    let segmentTitle = "";
    segments.map(segment => {
        if ((segmentKey && segment.key === segmentKey) || (!segmentKey && segment.isDefault))
            segmentTitle = segment.name;

    });
    return {
        staticData: state.staticData,
        segmentTitle,
        segments
    };
};

const mapDispatchToProps = () => {
    return {
        changeSegment: (staticData, segment) => {
            window.location.assign(redirectPage(URLs.STORE, staticData) + "?mode=preview&segment=" + segment);
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SegmentsMenu);




// WEBPACK FOOTER //
// ./src/containers/common/SegmentsMenu.js